export default __webpack_public_path__ + "static/media/olivier.52608841.jfif";